<template>
    <div>
        <template v-if="crud_region === true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Region </h1>
            </div>
            <div class="global-main">
                <form id="regionForm" @submit.prevent="addRegion">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/regions" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_region === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_region === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                region : {},
                form: new Form({
                    name : '',
                }),
                crud_region: null,
            }
        },
        methods: {
            addRegion() {
                this.$Progress.start();
                this.form.post('api/addRegion')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Region created successfully'
                        });
                        this.$router.push('/regions');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_region').then(result => {
                this.crud_region = result.crud_region;
            }).then(result => {
                if(this.crud_region == true){
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
